import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

type Props = {
  text?: string;
  to?: string | -1;
}

const BackButton = ({ text = 'Regresar', to = '/' }: Props) => {
  const navigate = useNavigate();

  const handleClickBack = () => {
    navigate(to as any);
  };
  return (
    <motion.div onClick={handleClickBack} whileTap={{ scale: 0.95 }} className="inline-flex items-center rounded-full text-lg border border-black bg-gray py-2 pl-2 pr-4 xl:py-3 xl:pl-3 xl:pr-6">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 xl:h-7 w-6 xl:w-7 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      { text }
    </motion.div>
  );
};

export default BackButton;
